import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeletePodcastMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.deletePodcast,
  {
    mutationKey: ['deletePodcast'],
  },
)
